import TKFilter, { FilterData, URLParams } from '@tk/components/tk.filter';

export default class TCFilter extends TKFilter {
    constructor() {
        super();
    }

    mergeURLParamsByData(data: FilterData, shouldReset: boolean = false): URL {
        const url = TKFilter.mergeURLs(this.filterURL) || new URL(window.location.href);
        const searchParamList = Array.from(url.searchParams);
        let filteredList = searchParamList.filter((item) => !item[0].startsWith(this.groupId));
        filteredList = filteredList.filter((param) => !param[0].startsWith('ppos')); // reset Paging
        const existingParams: URLParams = Object.fromEntries(filteredList);
        const mergedParams: URLParams = shouldReset ? { ...existingParams } : { ...data, ...existingParams };
        url.search = new URLSearchParams(mergedParams).toString();
        return url;
    }

}